import moment from 'moment';
import IntAssessHdrService from "@/service/IntAssessHdrService";
import { IntAssessHdr } from "@/model/IntAssessHdr";
import { IntAssessDtl } from "@/model/IntAssessDtl";
import SweetAlertService from "@/service/SweetAlertService";
import UserService from "@/service/UserService";
import JobsService from "@/service/JobsService";
import StoreGetter from "@/constants/StoreGetter";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import DatePicker from "vue2-datepicker";
import interviewScheduleValidatonObj from "./S110000-InterviewScheduleValidaton.js";
var interviewScheduleDataValidatonObj = new interviewScheduleValidatonObj();
export default {
  name: "InterviewStart",
  components: {
    DatePicker
  },
  mounted() {
    interviewScheduleDataValidatonObj.interviewScheduleValidaton();
    this.getAllJob();
  },
  data: () => ({
    e1: 1,
    interviewScheduleLocalization: t,
    interviewScheduleDictEnum: dictEnum,
    date: new Date(),
    type: 'date',
    intAssessHdr: new IntAssessHdr(),
    intAssessDtl: new IntAssessDtl(),
    selectedAssessTemp: {
      Grp: "",
      Item: "",
      OptRadioList: []
    },
    jobCodeList: [],
    groupList: [],
    assessTempList: [],
    payCycleTypeList: [],
    jobCode: '',
    candId: '',
    intAssessHdrList: [],
    selectedAssessHdr: new IntAssessHdr(),
    activeTab: 'Interview',
    statusList: [],
    IsInterviewerAndFinalApprover: false,
    IsViewMode: false,
    currentIntAssessHdr: new IntAssessHdr(),
    userList: [],
    IsMenuActive: false,
    AnotherInterviewTime: '',
    IsTimeMenuActive: false,
    InterviewStatus:'',
  }),
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    formattedDate() {
      return this.date &&
        moment(this.date).format('YYYY-MM-DD') != '1900-01-01'
        ? moment(this.date).format('YYYY-MM-DD')
        : undefined;
    },
  },
  methods: {
    async getAllIntAssessHdrList() {
      var self = this;
      const obj = {};
      const response = await IntAssessHdrService.getAllIntAssessHdrList(obj);
      if (response.data.IsSuccess) {
        self.intAssessHdrList = response.data.Data;
        if (self.intAssessHdrList != null && self.intAssessHdrList.length > 0) {
          self.intAssessHdrList.forEach(
            (element) => {
              if (element.DateCommence != null && element.DateCommence != "") {
                element.DateCommence = moment(String(element.DateCommence)).format("YYYY-MM-DD");
              }
              else {
                element.DateCommence = '1900-01-01';
              }
              var jobCodeDetail = self.jobCodeList.find((obj) => obj.JobCode == element.JobCode);
              if (jobCodeDetail != null && jobCodeDetail != undefined) {
                element.JobName = self.user.Lang == 'EN' ? jobCodeDetail.EDesc : jobCodeDetail.CDesc;
              }
            });
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllIntAssessHdrByCandIdAndJobCode() {
      var self = this;
      if (self.candId == '' && self.jobCode == '') {
        SweetAlertService.warning("Warn", self.interviewScheduleLocalization.t(self.interviewScheduleDictEnum.WARN_SelectSearch));
        return;
      }
      const obj = {
        candId: self.candId,
        jobCode: self.jobCode
      };
      const response = await IntAssessHdrService.getAllIntAssessHdrByCandIdAndJobCode(obj);
      if (response.data.IsSuccess) {
        self.intAssessHdrList = response.data.Data;
        if (self.intAssessHdrList != null && self.intAssessHdrList.length > 0) {
          self.intAssessHdrList.forEach(
            (element) => {
              if (element.DateCommence != null && element.DateCommence != "") {
                element.DateCommence = moment(String(element.DateCommence)).format("YYYY-MM-DD");
              }
              else {
                element.DateCommence = '1900-01-01';
              }
              var jobCodeDetail = self.jobCodeList.find((obj) => obj.JobCode == element.JobCode);
              if (jobCodeDetail != null && jobCodeDetail != undefined) {
                element.JobName = self.user.Lang == 'EN' ? jobCodeDetail.EDesc : jobCodeDetail.CDesc;
              }
            });
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllJob() {
      var self = this;
      const obj = {};
      const response = await JobsService.getAllJobs(obj);
      if (response.data.IsSuccess) {
        self.jobCodeList = response.data.Data;
        self.getAllIntAssessHdrList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getIntAssessHdrDetail() {
      var self = this;
      const obj = {
        candId: self.selectedAssessHdr.CandID,
        jobAdCode: self.selectedAssessHdr.JobAdCode,
        seq: self.selectedAssessHdr.Seq,
      };
      const response = await IntAssessHdrService.getIntAssessHdrDetail(obj);
      if (response.data.IsSuccess) {
        self.intAssessHdr.JobName = "";
        self.intAssessHdr = response.data.Data;
        if (self.intAssessHdr.DateCommence != null && self.intAssessHdr.DateCommence != "") {
          var dateCommence = moment(String(self.intAssessHdr.DateCommence)).format("YYYY-MM-DD");
          if (dateCommence == '1900-01-01') {
            self.intAssessHdr.DateCommence = moment().format("YYYY-MM-DD");
          }
          else {
            self.intAssessHdr.DateCommence = dateCommence;
          }
        }
        var jobCodeDetail = self.jobCodeList.find((obj) => obj.JobCode == self.intAssessHdr.JobCode);
        if (jobCodeDetail != null && jobCodeDetail != undefined) {
          self.intAssessHdr.JobName = self.user.Lang == 'EN' ? jobCodeDetail.EDesc : jobCodeDetail.CDesc;
        }
        var finalApproverDetail = self.jobCodeList.find((obj) => obj.JobCode == self.intAssessHdr.JobCode && obj.FinalApprover == self.user.UserID);
        if (finalApproverDetail != null && finalApproverDetail != undefined) {
          if (self.intAssessHdr.Interviewer == self.user.UserID) {
            self.IsInterviewerAndFinalApprover = true;
          }
          else {
            self.intAssessHdr.IsFinalApprover = true;
          }
        }
        if (Number(self.currentIntAssessHdr.Seq) != Number(self.selectedAssessHdr.Seq)) {
          self.IsViewMode = true;
        }
        else {
          if (self.IsInterviewerAndFinalApprover) {
            self.IsViewMode = false;
          }
          else if (self.intAssessHdr.IsFinalApprover || self.intAssessHdr.Interviewer != self.user.UserID) {
            self.IsViewMode = true;
          }
          else {
            self.IsViewMode = false;
          }
        }
        if (self.intAssessHdr.IntStatus == "30") {
          self.intAssessHdr.AnotherInterviewSch = moment(self.intAssessHdr.DateInt).format("YYYY-MM-DD");
          self.AnotherInterviewTime = moment(self.intAssessHdr.DateInt).format("HH:mm");
        }
        else {
          self.intAssessHdr.AnotherInterviewSch = moment().format("YYYY-MM-DD HH:mm");
          self.AnotherInterviewTime = "";
        }
        self.intAssessHdr.DateInt = moment(self.intAssessHdr.DateInt).format("YYYY-MM-DD HH:mm");
        self.getPayCycleType();
        self.getAllAssessTemp();
        self.getAllStatus();
        self.getAllUsers();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    onSelectIntAssessHdr(intAssessHdr) {
      var self = this;
      self.InterviewStatus = "";
      self.IsInterviewerAndFinalApprover = false;
      self.currentIntAssessHdr = intAssessHdr;
      self.currentIntAssessHdr.DateAdd = moment(String(intAssessHdr.DateAdd)).format("YYYY-MM-DD");
      self.selectedAssessHdr = intAssessHdr;
      self.getIntAssessHdrDetail();
    },
    changeInterview: function (seq) {
      var self = this;
      self.InterviewStatus = "";
      self.selectedAssessHdr = new IntAssessHdr();
      self.intAssessHdr = new IntAssessHdr();
      self.intAssessDtl = new IntAssessDtl();
      self.$validator.reset();
      self.vErrors.clear();
      self.selectedAssessHdr.CandID = self.currentIntAssessHdr.CandID;
      self.selectedAssessHdr.JobAdCode = self.currentIntAssessHdr.JobAdCode;
      self.selectedAssessHdr.Seq = Number(seq);
      self.getIntAssessHdrDetail();
    },
    async getAllAssessTemp() {
      var self = this;
      const obj = {};
      const response = await IntAssessHdrService.getAllAssessTemp(obj);
      if (response.data.IsSuccess) {
        response.data.Data = response.data.Data.filter((x) => x.Type == "INT")
        var groupList = response.data.Data.filter(
          obj => obj.Item == 0
        );
        self.groupList = groupList;
        self.activeTab = self.groupList[0].EDesc;
        self.selectedAssessTemp = self.groupList[0];
        var assessTempList = response.data.Data.filter(
          obj => obj.Item !== 0
        );
        if (self.intAssessHdr.IntAssessDtlList != null && self.intAssessHdr.IntAssessDtlList.length > 0 && assessTempList != null && assessTempList.length > 0) {
          assessTempList.forEach((element) => {
            var intAssessDtlDetail = self.intAssessHdr.IntAssessDtlList.find((obj) => obj.Grp == element.Grp && obj.Item == element.Item);
            if (intAssessDtlDetail != null && intAssessDtlDetail != undefined) {
              element.Ans = intAssessDtlDetail.Ans;
              element.Rem = intAssessDtlDetail.Rem;
            }
          }
          );
        }
        self.assessTempList = assessTempList;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getPayCycleType() {
      var self = this;
      const obj = {};
      const response = await IntAssessHdrService.getPayCycleType(obj);
      if (response.data.IsSuccess) {
        self.payCycleTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllStatus() {
      var self = this;
      const obj = {};
      const response = await IntAssessHdrService.getAllStatus(obj);
      if (response.data.IsSuccess) {
        var statusList = response.data.Data;
        if (statusList != null && statusList.length > 0) {
          self.statusList = statusList.filter(obj => obj.StatusCode == '30' || obj.StatusCode === '40' || obj.StatusCode === '50' || obj.StatusCode === '80');
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    onTabChange: function (data) {
      this.selectedAssessTemp = data;
      this.activeTab = data.EDesc;
    },
    changeRecommandation: function () {
      var self = this;
      if (self.intAssessHdr.IntStatus != '80') {
        self.intAssessHdr.JobCode = "";
        self.intAssessHdr.DateCommence = moment().format("YYYY-MM-DD");;
        self.intAssessHdr.BasicSalary = "";
        self.intAssessHdr.SalPayCycle = "";
        self.intAssessHdr.Allw = "";
        self.intAssessHdr.PayCycle = "";
        self.intAssessHdr.JobName = "";
      }
      if (self.intAssessHdr.IntStatus != '30') {
        self.intAssessHdr.AnotherInterviewSch = moment().format("YYYY-MM-DD HH:mm");
        self.AnotherInterviewTime = "";
        self.intAssessHdr.AnotherInterviewerName = "";
      }
    },
    OnJobCodeBtnClick: function () {
      $("#jobCodeModel").modal("show");
    },
    OnJobCodeSelect: function (model) {
      var self = this;
      self.intAssessHdr.JobCode = model.JobCode;
      var jobName = self.user.Lang == 'EN' ? model.EDesc : model.CDesc;
      self.intAssessHdr.JobName = model.JobCode + "-" + jobName;
      $("#jobCodeModel").modal("hide");
    },
    //Interview Start Method
    submitIntAssessPopup: function (status) {
      var self = this;
      self.InterviewStatus = status;
      if (self.InterviewStatus != '90') {
        $('#submitOfferModel').modal('show');
      }
      else if (self.InterviewStatus == '90') {
        $('#rejectModel').modal('show');
      }
    },
    openRejectReasonPopup: function () {
      $('#rejectModel').modal('hide');
      $('#rejectReasonModel').modal('show');
    },
    closeIntAssessPopup: function () {
      var self = this;
      self.InterviewStatus = "";
      $('#submitOfferModel').modal('hide');
      $('#rejectModel').modal('hide');
      $('#rejectReasonModel').modal('hide');
    },
    async saveIntAssessHdrData() {
      var self = this;
      if (self.InterviewStatus == 90 && self.intAssessHdr.IntAssessLogModel.LogMsg == "") {
        SweetAlertService.warning("Warn", "Reject Reason");
        return;
      }
      self.intAssessHdr.IntStatus = self.InterviewStatus;
      $('#submitOfferModel').modal('hide');
      $('#rejectModel').modal('hide');
      $('#rejectReasonModel').modal('hide');
      if (self.intAssessHdr.DateCommence != null && self.intAssessHdr.DateCommence != "") {
        self.intAssessHdr.DateCommence = moment(String(self.intAssessHdr.DateCommence)).format("YYYY-MM-DD");
      }
      else {
        self.intAssessHdr.DateCommence = '1900-01-01';
      }
      if (self.intAssessHdr.DateInt != null && self.intAssessHdr.DateInt != "") {
        self.intAssessHdr.DateInt = moment(String(self.intAssessHdr.DateInt)).format("YYYY-MM-DD HH:mm");
      }
      else {
        self.intAssessHdr.DateInt = '1900-01-01 00:00';
      }
      self.intAssessHdr.BasicSalary = Number(self.intAssessHdr.BasicSalary);
      self.intAssessHdr.Allw = Number(self.intAssessHdr.Allw);
      self.intAssessHdr.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
      self.intAssessHdr.AddBy = self.$store.getters[StoreGetter.user].UserID;
      self.intAssessHdr.IntAssessLogModel.CandID = self.intAssessHdr.CandID;
      self.intAssessHdr.IntAssessLogModel.JobAdCode = self.intAssessHdr.JobAdCode;
      self.intAssessHdr.IntAssessLogModel.Seq = Number(self.intAssessHdr.Seq);
      self.intAssessHdr.IntAssessLogModel.IntStatus = self.intAssessHdr.IntStatus;
      self.intAssessHdr.IntAssessLogModel.LogBy = self.$store.getters[StoreGetter.user].UserID;
      var obj = {
        model: self.intAssessHdr,
      }
      self.saveIntAssessHdr(obj);
    },
    async saveIntAssessHdr(obj) {
      var self = this;
      const response = await IntAssessHdrService.updateIntSchedule(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", self.interviewScheduleLocalization.t(self.interviewScheduleDictEnum.MSG_InterviewSubmit));
        self.resetData();
        self.getAllIntAssessHdrList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    resetData: function () {
      var self = this;
      self.InterviewStatus = "";
      self.AnotherInterviewTime = "";
      self.currentIntAssessHdr = new IntAssessHdr();
      self.selectedAssessHdr = new IntAssessHdr();
      self.intAssessHdr = new IntAssessHdr();
      self.intAssessDtl = new IntAssessDtl();
      self.IsMenuActive = false;
      self.$validator.reset();
      self.vErrors.clear();
    },
    //Update Interview Update  Method
    async getAllUsers() {
      var self = this;
      const obj = {
        searchText: ""
      };
      const response = await UserService.getAllUsers(obj);
      if (response.data.IsSuccess) {
        self.userList = response.data.Data;
        if (self.userList != null && self.userList.length > 0 && self.intAssessHdr != null) {
          var userDetail = self.userList.find((obj) => obj.UserID == self.intAssessHdr.Interviewer);
          if (userDetail != null && userDetail != undefined) {
            var userName = self.user.Lang == 'EN' ? userDetail.EngName : userDetail.ChiName;
            self.intAssessHdr.UserName = userName;
          }
          if (self.intAssessHdr.IntStatus == "30") {
            var anotherUserDetail = self.userList.find((obj) => obj.UserID == self.intAssessHdr.Interviewer);
            if (anotherUserDetail != null && anotherUserDetail != undefined) {
              var anotherUserName = self.user.Lang == 'EN' ? anotherUserDetail.EngName : anotherUserDetail.ChiName;
              self.intAssessHdr.AnotherInterviewerName = anotherUserName;
            }
          }
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnUserBtnClick: function () {
      $("#userModel").modal("show");
    },
    OnUserSelect: function (model) {
      var self = this;
      self.intAssessHdr.AnotherInterviewer = model.UserID;
      var userName = self.user.Lang == 'EN' ? model.EngName : model.ChiName;
      self.intAssessHdr.AnotherInterviewerName = userName;
      $("#userModel").modal("hide");
    },
    updateIntAssessPopup: function () {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.intAssessHdr.IntAssessDtlList = [];
          self.assessTempList.forEach((value) => {
            if (value.AnsType == 'RAD') {
              if (value.Ans != '') {
                self.intAssessDtl = new IntAssessDtl();
                self.intAssessDtl.CandID = self.intAssessHdr.CandID;
                self.intAssessDtl.JobAdCode = self.intAssessHdr.JobAdCode;
                self.intAssessDtl.Seq = Number(self.intAssessHdr.Seq);
                self.intAssessDtl.Grp = value.Grp;
                self.intAssessDtl.Item = value.Item;
                self.intAssessDtl.Ans = value.Ans;
                self.intAssessDtl.Rem = value.Rem;
                self.intAssessHdr.IntAssessDtlList.push(self.intAssessDtl);
              }
            }
          });
          if (self.intAssessHdr.IntAssessDtlList.length > 0) {
            $('#submitInterviewModel').modal('show');
          }
          else {
            SweetAlertService.warning("Warn", self.interviewScheduleLocalization.t(self.interviewScheduleDictEnum.WARN_FillInformation));
          }
        }
        else {
          SweetAlertService.warning("Warn", self.interviewScheduleLocalization.t(self.interviewScheduleDictEnum.MSG_ValidationFailed));
        }
      });
    },
    async updateIntAssessHdrData() {
      var self = this;
      $('#submitInterviewModel').modal('hide');
      self.intAssessHdr.CandID = self.intAssessHdr.CandID;
      self.intAssessHdr.JobAdCode = self.intAssessHdr.JobAdCode;
      self.intAssessHdr.Seq = Number(self.intAssessHdr.Seq);
      if (self.intAssessHdr.IntStatus == '30' && self.intAssessHdr.AnotherInterviewSch != undefined && self.intAssessHdr.AnotherInterviewSch != null) {
        var newDate = moment(self.intAssessHdr.AnotherInterviewSch).format("YYYY-MM-DD");//new Date(self.candidateInvited.Opt1Date);
        self.intAssessHdr.AnotherInterviewSch = newDate + " " + self.AnotherInterviewTime; // moment(new Date(year,month,date,hour,minutes)).format("YYYY-MM-DD HH:mm");
      }
      else {
        self.intAssessHdr.AnotherInterviewSch = moment().format("YYYY-MM-DD HH:mm");
      }
      if (self.intAssessHdr.DateCommence != null && self.intAssessHdr.DateCommence != "" && self.intAssessHdr.IntStatus == '80') {
        self.intAssessHdr.DateCommence = moment(String(self.intAssessHdr.DateCommence)).format("YYYY-MM-DD");
      }
      else {
        self.intAssessHdr.DateCommence = '1900-01-01';
      }
      if (self.intAssessHdr.DateInt != null && self.intAssessHdr.DateInt != "") {
        self.intAssessHdr.DateInt = moment(String(self.intAssessHdr.DateInt)).format("YYYY-MM-DD HH:mm");
      }
      else {
        self.intAssessHdr.DateInt = '1900-01-01 00:00';
      }
      if (self.intAssessHdr.AnotherInterviewer == "") {
        self.intAssessHdr.AnotherInterviewer = self.intAssessHdr.Interviewer;
      }
      self.intAssessHdr.BasicSalary = Number(self.intAssessHdr.BasicSalary);
      self.intAssessHdr.Allw = Number(self.intAssessHdr.Allw);
      self.intAssessHdr.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
      self.intAssessHdr.AddBy = self.$store.getters[StoreGetter.user].UserID;
      self.intAssessHdr.IntAssessLogModel.CandID = self.intAssessHdr.CandID;
      self.intAssessHdr.IntAssessLogModel.JobAdCode = self.intAssessHdr.JobAdCode;
      self.intAssessHdr.IntAssessLogModel.Seq = Number(self.intAssessHdr.Seq);
      self.intAssessHdr.IntAssessLogModel.IntStatus = self.intAssessHdr.IntStatus;
      self.intAssessHdr.IntAssessLogModel.LogBy = self.$store.getters[StoreGetter.user].UserID;
      var obj = {
        model: self.intAssessHdr,
      }
      self.updateIntAssessHdr(obj);
    },
    async updateIntAssessHdr(obj) {
      var self = this;
      const response = await IntAssessHdrService.saveIntSchedule(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", self.interviewScheduleLocalization.t(self.interviewScheduleDictEnum.MSG_InterviewSubmit));
        self.resetData();
        self.getAllIntAssessHdrList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    closeSubmitIntAssessPopup: function () {
      var self = this;
      $('#submitInterviewModel').modal('hide');
    },
    clearCandidateData: function () {
      var self = this;
      self.jobCode = "";
      self.candId = "";
      self.IsInterviewerAndFinalApprover = false;
      self.IsViewMode = false;
      self.IsTimeMenuActive = false;
      self.resetData();
      self.getAllIntAssessHdrList();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S110000-InterviewSchedule/S110000-InterviewSchedule.js